import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  card: {
    ...theme.standarts('card'),

    display: 'flex',
    flexDirection: 'column',
    boxShadow: theme.getBoxShadow('card'),
    borderStyle: 'none',
    borderRadius: theme.get('card', 'border.radius'),
    margin: 0,
    padding: theme.getFactor('card', 'indent', 2),
    gap: theme.getFactor('card', 'indent', 0.5),

    position: 'relative'
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  shadowed: {
    backgroundColor: theme.getColor('card', color, 'value'),
    color: theme.getColor('card', color, 'contrast')
  },

  bordered: {
    backgroundColor: theme.getColor('card', color, 'value'),
    color: theme.getColor('card', color, 'contrast'),

    boxShadow: 'none',
    borderStyle: theme.get('card', 'border.style'),
    borderWidth: theme.get('card', 'border.width'),
    borderColor: theme.getColor('card', color, 'border'),
    borderRadius: theme.getFactor('card', 'border.radius', 0.5),
    padding: theme.get('card', 'indent')
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap
      }
    };

    static propTypes = {
      variant: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    };

    static defaultProps = {
      variant: 'shadowed',
      color: 'basic'
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, className, children, variant, color, ...props } =
        this.props;

      const mergedClassName = mergeClassName(
        className,
        classes.main.card,
        (classes.variant[color] ?? classes.variant.basic)[variant]
      );

      return (
        <div {...props} className={mergedClassName}>
          {children}
        </div>
      );
    }
  }
);
